import PathwayParentAccountReportsContainer from './pathway_parent_account_reports_container';

const PathwayParentAccountReports = PathwayParentAccountReportsContainer;
export default PathwayParentAccountReports;
